import React, { useContext, useEffect } from 'react';
import { motion, Transition } from 'framer-motion';
import { useLocation, useLoaderData } from 'react-router-dom';
import { text } from '../data';
import { AnimationContext } from '../contexts/PageContext';
import { PageAnimation, PageData } from '../types/types';
import { trackGuidedHelpPath } from '../../analytics/engineering-tools';

interface AnimationScreenProps {
	children: React.ReactNode;
}

declare global {
	interface Window {
		dataLayer?: Record<string, unknown>[];
	}
}

const AnimationScreen: React.FC<AnimationScreenProps> = ( { children } ) => {
	const location = useLocation();
	const data = useLoaderData() as PageData;

	useEffect( () => {
		trackGuidedHelpPath( data.id );
	}, [ location ] );

	const TRANSLATE_X = 600;

	const animation: PageAnimation = useContext( AnimationContext );

	const variants = {
		enter: ( direction: number ) => {
			return {
				x: TRANSLATE_X * direction,
				opacity: 0,
			};
		},
		center: {
			x: 0,
			opacity: 1,
		},
		exit: ( direction: number ) => {
			return {
				x: -1 * TRANSLATE_X * direction,
				opacity: 0,
			};
		},
	};

	const transition: Transition = {
		duration: 0.5,
		ease: 'easeInOut',
	};

	return (
		<motion.div
			className="c-guided-help__container"
			variants={variants}
			custom={animation.direction}
			initial="enter"
			animate="center"
			exit="exit"
			transition={transition}
		>
			<div className="c-guided-help__exit">
				<a href="/" className="btn btn--tertiary-mono" data-link-click>
					{text.homeLink}
				</a>
			</div>
			{children}
		</motion.div>
	);
};

export default AnimationScreen;
